/* Default public content — kept in sync with backend/default_content.py.
   Used as fallback when settings haven't loaded yet so the site never
   shows empty texts during the initial fetch. */

export const DEFAULT_CONTENT = {
  home: {
    hero_top_label: "depuis 2014",
    hero_title_line1: "ECO-GEST",
    hero_title_line2: "PATRIMOINE",
    hero_bullets: ["Économie de la Construction", "Maîtrise d'Œuvre d'Exécution", "OPC"],
    hero_description: "Un accompagnement rigoureux et personnalisé pour la réussite de vos projets de construction.",
    hero_cta_primary: "Découvrir nos réalisations",
    hero_cta_secondary: "Nous contacter",
    hero_scroll_hint: "↓ Découvrir",
    expertises_title: "Nos domaines d'expertise",
    expertises: [
      { key: "economie", icon: "calculator", number: "01", title: "ÉCONOMIE DE LA CONSTRUCTION",
        items: ["Estimation des coûts", "Études économiques", "Assistance à maîtrise d'ouvrage", "Optimisation budgétaire"],
        link: "/metiers#economie", link_label: "En savoir plus" },
      { key: "moex", icon: "hardhat", number: "02", title: "MAÎTRISE D'ŒUVRE D'EXÉCUTION",
        items: ["Suivi des travaux", "Contrôle qualité", "Respect des délais", "Coordination terrain"],
        link: "/metiers#moex", link_label: "En savoir plus" },
      { key: "opc", icon: "gantt", number: "03", title: "OPC",
        items: ["Ordonnancement", "Pilotage", "Coordination", "Gestion des plannings"],
        link: "/metiers#opc", link_label: "En savoir plus" },
    ],
    values_title: "Une structure à taille humaine",
    values: [
      { icon: "users", title: "Proximité", text: "Une relation directe avec chaque client." },
      { icon: "shield", title: "Rigueur", text: "Suivi précis à chaque étape." },
      { icon: "zap", title: "Réactivité", text: "Des décisions rapides." },
      { icon: "handshake", title: "Accompagnement", text: "Du premier rendez-vous jusqu'à la livraison." },
    ],
    featured_title: "Quelques réalisations",
    featured_cta: "Voir toutes nos réalisations",
    qualifications_title: "Nos qualifications",
  },
  entreprise: {
    hero_title: "L'ENTREPRISE",
    hero_breadcrumb: "Accueil / L'entreprise",
    hero_image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=2400&q=80",
    qui_title: "QUI SOMMES-NOUS ?",
    qui_paragraphs: [
      "ECO-GEST PATRIMOINE SAS est un bureau d'études et de maîtrise d'œuvre spécialisé dans l'économie de la construction, la maîtrise d'œuvre d'exécution et l'ordonnancement, pilotage et coordination de projets.",
      "Notre structure à taille humaine nous permet d'offrir à nos clients une relation de proximité, une disponibilité constante et un engagement total à chaque étape de leurs projets.",
    ],
    values: [
      { icon: "users", title: "À taille humaine", text: "Une équipe réactive et disponible." },
      { icon: "handshake", title: "Engagement", text: "Nous nous investissons pleinement dans chaque projet." },
      { icon: "award", title: "Expérience", text: "Des compétences solides au service de vos ambitions." },
      { icon: "shield", title: "Confiance", text: "Des relations durables basées sur la transparence et la fiabilité." },
    ],
    team_title: "NOTRE ÉQUIPE",
    stats: [
      { icon: "folder", value: 50, suffix: "+", label: "Projets réalisés" },
      { icon: "calendar", value: 15, suffix: "+", label: "Années d'expérience" },
      { icon: "heart", value: 100, suffix: "%", label: "Clients satisfaits" },
      { icon: "layers", value_text: "1–5", label: "Collaborateurs" },
    ],
    cta_title: "Besoin d'un accompagnement sur votre projet ?",
    cta_text: "Contactez-nous pour échanger sur vos besoins.",
    cta_button: "Nous contacter",
  },
  metiers: {
    hero_title: "NOS MÉTIERS",
    hero_breadcrumb: "Accueil / Nos métiers",
    hero_image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=2400&q=80",
    intro_title_line1: "TROIS EXPERTISES COMPLÉMENTAIRES",
    intro_title_line2: "POUR DES PROJETS MAÎTRISÉS",
    metiers: [],
    cta_title: "Besoin d'un accompagnement sur votre projet ?",
    cta_text: "Contactez-nous pour échanger sur vos besoins.",
    cta_button: "Nous contacter",
  },
  realisations: {
    hero_title: "RÉALISATIONS",
    hero_breadcrumb: "Accueil / Réalisations",
    hero_image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=2400&q=80",
  },
  contact: {
    hero_title: "CONTACT",
    hero_breadcrumb: "Accueil / Contact",
    hero_image: "https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=2400&q=80",
    form_title: "Nous contacter",
    form_submit_label: "Envoyer le message",
    form_success_message: "Votre message a bien été envoyé. Nous vous répondons sous 24h ouvrées.",
  },
  footer: {
    description: "Bureau d'études en économie de la construction, maîtrise d'œuvre d'exécution et OPC.",
    slogan: "CONSTRUISONS ET GÉRONS ENSEMBLE L'AVENIR",
    copyright_suffix: "Tous droits réservés.",
    credits: "Site conçu avec rigueur et précision.",
  },
  global_cta: {
    header_contact: "Nous contacter",
  },
  legal: {
    hero_title: "Mentions légales",
    hero_kicker: "Informations légales",
    intro: "",
    sections: [],
    last_update: "",
  },
  privacy: {
    hero_title: "Politique de confidentialité",
    hero_kicker: "Protection des données (RGPD)",
    intro: "",
    sections: [],
    last_update: "",
  },
};

export const DEFAULT_THEME = {
  accent: "#E60000",
  accent_hover: "#B30000",
  dark: "#1A1A1A",
  dark_alt: "#262626",
  light_bg: "#F9F9F9",
  muted_bg: "#F4F4F4",
};
